import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import Docnmore from "../../Assets/Projects/docnmore.png";
import goki from "../../Assets/Projects/gokiapp.png";
import pwc from "../../Assets/Projects/riskdetect.webp";
import gokimobile from "../../Assets/Projects/goki-mobile.png";
import Arsonex from "../../Assets/Projects/1.png";
import RTpro from "../../Assets/Projects/Order.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={goki}
              isBlog={false}
              title="Goki Dashboard"
              description="Goki is the first hospitality product of its kind. We combine hardware, software & guest services to make stays better for everyone. Our properties offer a contactless guest experience, improve operational efficiencies & direct guests to their ancillary revenue streams."
              // ghLink="https://github.com/soumyajit4419/Chatify"
              demoLink="https://www.gokitech.com/gboard"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pwc}
              isBlog={false}
              title="Risk Detect"
              description="Stay vigilant against fraud, corruption and compliance issues. Our platform targets high-risk activity with continuous monitoring and thorough document reviews. Get to key data quickly and better allocate resources through advanced analytics and AI."
              demoLink="https://www.pwc.com/us/en/products/risk-detect.html"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={RTpro}
              isBlog={false}
              title="Rental Track Pro"
              description="Rental Tracker Pro (RTPro) offers a solution to organize, simplify, and gain control over your inventory and operations. The software is ideal for the Costume and Property shops."
              demoLink="https://rentaltracker.com/RTPro-Costume-Property-Drapery-Edition"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gokimobile}
              isBlog={false}
              title="Goki Mobile"
              description="Goki is the first hospitality product of its kind. We combine hardware, software & guest services to make stays better for everyone. Our properties offer a contactless guest experience, improve operational efficiencies & direct guests to their ancillary revenue streams."
              demoLink="https://www.gokitech.com/software"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Docnmore}
              isBlog={false}
              title="Docnmore"
              description="Docnmore is a platform that allows users to easily find and book appointments with doctors and other healthcare professionals. The platform is designed to be easy to use and user-friendly, with a simple interface that makes it easy for users to find and book appointments with healthcare professionals.
              Also, it allows users to easily access their medical records and other important information, making it easier for them to manage their health. You can see doctores profile and book appointment with them."
              // ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              demoLink="https://www.linkedin.com/company/bluefoxai/"
            />
          </Col>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Arsonex}
              isBlog={false}
              title="Arsonex"
              description=" Arsonex is a cryptocurrency exchange platform that allows users to trade cryptocurrencies. It is a platform that allows users to buy and sell cryptocurrencies. The platform is designed to be easy to use and user-friendly, with a simple interface that makes it easy for users to trade cryptocurrencies."
              demoLink="https://dev.paydirham.me/"  
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
